export default "__VITE_PUBLIC_ASSET__525b7775__"